module.exports = __webpack_public_path__ + "static/img/arinkel-3.54654d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/arinkel-3.jpg
// module id = 0ZiX
// module chunks = 1